import { render, staticRenderFns } from "./bom_cost.vue?vue&type=template&id=084ca331&scoped=true&"
import script from "./bom_cost.vue?vue&type=script&lang=js&"
export * from "./bom_cost.vue?vue&type=script&lang=js&"
import style0 from "./bom_cost.vue?vue&type=style&index=0&id=084ca331&scoped=true&lang=less&"
import style1 from "./bom_cost.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ca331",
  null
  
)

export default component.exports